// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3MiHF","author":"Table_author__2NIq2","authorImage":"Table_authorImage__2zD1g","unreadRow":"Table_unreadRow__2wLmf"};